import _ from 'lodash'
import constants from '../constants'

const initialPreviewState = {
  options: [],
  preview_layers: [],
  base_price: 0,
  total_price: 0,
  comment: '',
};

const doorPreviewReducer = function(state = initialPreviewState, action) {
  switch(action.type) {
    case constants.ACTIONS.UPDATE_DOOR_PREVIEW:
      return Object.assign({}, state, action.payload);
  }

  return state;
};
export default doorPreviewReducer;


// WEBPACK FOOTER //
// ./app/javascript/app/reducers/door_preview.jsx